import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/**
 * Preset de PrimeNG para la Liga de Patinaje de Antioquia.
 *
 * Extiende Aura sobrescribiendo la paleta primaria con el verde de marca —kelly
 * #0e8e46 como 500, forest en los tonos oscuros— para que inputs, botones,
 * datepicker, tags y dialogs hereden la identidad sin tematizar uno por uno.
 * La rampa sale de `src/styles/ds/colors.css`.
 *
 * Es una copia de `01-lipatin-pagos-monorepo/apps/portal/src/app/theme/lipatin-preset.ts`,
 * no una derivacion nueva: matricula y pago son dos tramos del mismo recorrido y
 * partir de la misma rampa es lo que evita que se separen. Si la Liga revisa sus
 * colores, los dos archivos se sincronizan a mano.
 */
export const LipatinPreset = definePreset(Aura, {
  semantic: {
    // Rampa verde de marca (kelly + forest) como color primario
    primary: {
      50: '#e6f4ec',
      100: '#c3e4d1',
      200: '#9bd3b3',
      300: '#6fc192',
      400: '#3aa869',
      500: '#0e8e46', // --green-primary (kelly)
      600: '#0b7a3c', // --green-primary-600
      700: '#096a34', // --green-primary-700
      800: '#075428',
      900: '#0e4023', // --forest-800
      950: '#0a2e18', // --forest-900
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '#ffffff',
          hoverColor: '{primary.600}',
          activeColor: '{primary.700}',
        },
        highlight: {
          background: '{primary.50}',
          focusBackground: '{primary.100}',
          color: '{primary.700}',
          focusColor: '{primary.800}',
        },
      },
    },
  },
});
